import React from 'react';
import ResourceDettaglio from './ResourceDettaglio.jsx';
import ResourceFittingPanel from './ResourceFittingPanel.jsx';
import ResourceCvButton from './ResourceCvButton.jsx';
import { STATE_LABELS } from './kmLabels.js';

/* ═══════════════════════════════════════════════════════════
   Dettaglio risorsa dalla Console HR — finestra al centro.

   30/09: nato per la Console HR ("tasto occhio su ogni riga, apre il
   dettaglio ed eventualmente promuove lo stato"), riusando gli stessi
   componenti del SidePanel di MultifittingDashboard.

   15/10 — FE-01 / SIT-022 (UC-CD-01): il contenuto è ora ResourceDettaglio,
   lo STESSO componente del pannello laterale di MultiFitting, con la parte
   fissa nello stesso ordine (profilo, Self-Assessment, esperienze, stato,
   anagrafica). Cambiano solo il contenitore (qui finestra al centro, scelta
   del 15/10) e il blocco del fitting: qui il selettore di annuncio
   (ResourceFittingPanel), lasciato com'era e in fondo come prima, per
   decisione del 15/10. Rispetto a prima, dalla Console compaiono anche contatti, costi e
   disponibilità (da GET /resources/{id}) e le risorse Inbound e Da
   cancellare sono in sola lettura come in MultiFitting.

   Props invariate: i chiamanti (HrSelfAssessmentStatusPage) non cambiano.

   IMPORTANTE: resourceId qui deve essere un candidato_id (lo spazio id
   confermato equivalente al resourceId di /resources/{id} e
   /hr/risorse/{id}/invito-sa — vedi commento in SchedaCandidati). Non
   passare mai un consulente_id: quello spazio id non è confermato
   equivalente (vedi nota su SchedaConsulenti) e userebbe silenziosamente
   l'id sbagliato.
═══════════════════════════════════════════════════════════ */

const T = {
  border: 'rgba(0,0,0,0.12)',
  surface: '#FFFFFF',
  txt: '#1A1916',
  txt2: '#6B6A65',
};

export default function CandidatoDettaglioModal({
  resourceId,
  nome,
  email,
  statoCicloVita,
  sottostato,
  onClose,
  onResourceUpdated,
}) {
  const sottotitolo = [
    email && nome ? email : null,
    (sottostato || statoCicloVita) ? (STATE_LABELS[sottostato || statoCicloVita] || sottostato || statoCicloVita) : null,
  ].filter(Boolean).join(' · ');

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: T.surface, borderRadius: 14, width: '100%', maxWidth: 640, maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 12px 40px rgba(0,0,0,0.25)' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${T.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: T.txt }}>{nome || email || resourceId}</div>
            {sottotitolo && <div style={{ fontSize: 12.5, color: T.txt2 }}>{sottotitolo}</div>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* Bug Log 06/10 (3.1.2): CV reale in nuova scheda; il cvid Altamira si ricava da /resources/{id} */}
            <ResourceCvButton resourceId={resourceId} compact />
            <button type="button" onClick={onClose} aria-label="Chiudi" style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: T.txt2, lineHeight: 1 }}>×</button>
          </div>
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>
          <ResourceDettaglio
            resourceId={resourceId}
            statoCicloVita={statoCicloVita}
            onResourceUpdated={onResourceUpdated}
            bloccoInFondo={(
              <div style={{ padding: '12px 18px 18px' }}>
                <ResourceFittingPanel resourceId={resourceId} />
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
}
